import React, { useState } from 'react';
import Spinner from './Spinner';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const ImageWithSpinner = ({ imageUrl }) => {
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState(null);

  console.log('=== ImageWithSpinner Debug ===');
  console.log('imageUrl prop:', imageUrl);
  console.log('imageUrl type:', typeof imageUrl);
  console.log('imageUrl length:', imageUrl?.length);
  console.log('loading state:', loading);
  console.log('error state:', error);
  console.log('=============================');

  const handleImageLoad = () => {
    console.log('Image loaded successfully:', imageUrl);
    setLoading(false);
    setError(null);
  };

  const handleImageError = (e) => {
    console.error('Image failed to load:', imageUrl);
    console.error('Error event:', e);
    setLoading(false);
    setError('Failed to load image');
  };

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  // Don't render anything if no imageUrl is provided
  if (!imageUrl) {
    console.warn('ImageWithSpinner: No imageUrl provided');
    return (
      <div style={{
        padding: '20px',
        textAlign: 'center',
        border: '2px dashed #ccc',
        borderRadius: '8px',
        color: '#666'
      }}>
        No image URL provided
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
      <div style={{ position: 'relative' }}>
        {loading && !error && <Spinner />}

        {error ? (
          <div style={{
            width: 500,
            height: 800,
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            border: '2px dashed #dc3545',
            borderRadius: '8px',
            color: '#dc3545',
            backgroundColor: '#f8f9fa',
            marginBottom: '20px',
            paddingTop: '20px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <i className="fas fa-exclamation-triangle" style={{ fontSize: '48px', marginBottom: '10px' }}></i>
              <div>Failed to load image</div>
              <div style={{ fontSize: '12px', marginTop: '5px', wordBreak: 'break-all' }}>
                URL: {imageUrl}
              </div>
            </div>
          </div>
        ) : (
          <img
            src={imageUrl}
            onLoad={handleImageLoad}
            onError={handleImageError}
            style={{
              display: loading ? 'none' : 'block',
              width: 500,
              height: 800,
              marginBottom: '20px',
              objectFit: 'contain',
              border: '1px solid #ddd',
              borderRadius: '4px',
              verticalAlign: 'top'
            }}
            alt="Loaded content"
          />
        )}
      </div>

      {!loading && !error && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '20px'
        }}>
          <Button
            variant="outline-success"
            onClick={handleShowModal}
            style={{
              padding: '8px 16px'
            }}
          >
            <i className="fas fa-expand"></i> Expand Image
          </Button>
        </div>
      )}

      <Modal 
        show={showModal} 
        onHide={handleCloseModal}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Image Viewer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '80vh'
          }}>
            <img
              src={imageUrl}
              onError={(e) => {
                console.error('Modal image failed to load:', imageUrl);
                e.target.style.display = 'none';
                e.target.parentNode.innerHTML = `
                  <div style="text-align: center; color: #dc3545;">
                    <i class="fas fa-exclamation-triangle" style="font-size: 48px; margin-bottom: 10px;"></i>
                    <div>Failed to load image in modal</div>
                  </div>
                `;
              }}
              style={{
                maxWidth: '100%',
                maxHeight: '180vh',
                objectFit: 'contain'
              }}
              alt="Enlarged content"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ImageWithSpinner;
